import firebase from 'firebase'
import { db } from '../config/firebaseconfig'

function createUserInAuth (email, password) {
  return new Promise((resolve, reject) => {
    firebase.auth().createUserWithEmailAndPassword(email, password)
      .then( (user) => resolve(user) )
      .catch( (error) => reject(error.code))
  })
}

function createUserInDb ({uid, email, role, groups, managesGroups, displayName}) {
  return new Promise((resolve, reject) => {
    const date = new Date()
    const timestamp = date.getTime()
    db.collection('users').doc(uid).set({
      uid,
      email,
      role,
      groups,
      managesGroups,
      createdDate: timestamp,
      lastModifiedDate: timestamp,
      displayName      
    })
    /*firebase.database().ref('users/' + uid).set({
      uid,
      email,
      role,
      groups,
      managesGroups,
      createdDate: timestamp,
      lastModifiedDate: timestamp,
      displayName
    })*/
      .then( () => resolve(uid))
      .catch ( (error) => reject('db/set-failed'))
  })
}

export default function createUser (email, password, role, groups, managesGroups, displayName) {
  return createUserInAuth(email, password)
    .then( (user) => createUserInDb({
        uid: user.uid,
        email,
        role,
        groups,
        managesGroups,
        displayName
      })
      .then( () => null)
      .catch( (error) => console.log(error))
    )
    .catch( (error) => console.log(error))
}

/*

Error Codes from createUserWithEmailAndPassword: 

'auth/email-already-in-use'
Thrown if there already exists an account with the given email address.

'auth/invalid-email'
Thrown if the email address is not valid.

'auth/operation-not-allowed'
Thrown if email/password accounts are not enabled. Enable email/password accounts in the Firebase Console, under the Auth tab.

'auth/weak-password'
Thrown if the password is not strong enough.

*/


// WEBPACK FOOTER //
// ./src/helpers/createUser.js